<form class="event-add__form-container" [formGroup]="formGroup" #formDir="ngForm">
<h1 mat-dialog-title *ngIf="!isBusy" xmlns="http://www.w3.org/1999/html">Edit Event Photos</h1>
<div *ngIf="!isBusy; else spinner" class="event-edit-image__form-container">
  <fieldset class="event-edit-image__form-section">
    <legend class="event-edit-image__form-section-title">Event Photos</legend>
    <mat-dialog-content>
      <h4>Images (up to 3):</h4>
      <div class="event-edit-image__images-container">
        <mat-icon *ngIf="galleryImages && galleryImages.length < 3" (click)="openAddImageDialog()" class="add-icon" mat-tooltip="Add" aria-label="Add Image">add_circle</mat-icon>
        <span class="event-edit-image__images-spacer" *ngIf="galleryImages && galleryImages.length < 3"></span>
        <ngx-gallery *ngIf="galleryImages && galleryImages.length" [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
      </div>
      <div class="event-edit-image__images-deletebar" *ngIf="galleryImages && galleryImages.length >= 1">
        <span class="event-edit-image__images-delete-spacer" *ngIf="galleryImages && galleryImages.length < 3"></span>
        <span class="event-edit-image__images-delete-image" *ngFor="let image of galleryImages; let i = index">
        <mat-icon (click)="deleteImage(i)" class="delete-icon" mat-tooltip="Delete" aria-label="Delete Image">delete_outline</mat-icon>
      </span>
      </div>
    </mat-dialog-content>
  </fieldset>
  <mat-dialog-actions class="form-formatting">
    <button type="submit" id="saveButton" class="submit-button mat-raised-button" (click)="save()">
      Close
    </button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
</form>
